import { render, staticRenderFns } from "./original.vue?vue&type=template&id=1c942718&"
import script from "./original.vue?vue&type=script&lang=js&"
export * from "./original.vue?vue&type=script&lang=js&"
import style0 from "./original.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports